import { render, staticRenderFns } from "./task-todo.vue?vue&type=template&id=77fe3eb0&scoped=true&"
import script from "./task-todo.vue?vue&type=script&lang=js&"
export * from "./task-todo.vue?vue&type=script&lang=js&"
import style0 from "./task-todo.vue?vue&type=style&index=0&id=77fe3eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe3eb0",
  null
  
)

export default component.exports